var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1540(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BlueFlame_logo_rgb",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 269.34,
    height: 80,
    viewBox: "0 0 269.34 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.427,
    cy: -0.003,
    r: 1.048,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34cbd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#319dbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2e6da3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e5b99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.501,
    cy: 0.503,
    r: 0.498,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dedc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c5cc20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59b348"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.21,
    x2: 0.5,
    y2: -0.129,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e5b99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2e609c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2f71a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#308cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#319ebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#32b1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34cbd9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blue_Flame_RGB",
    "data-name": "Blue Flame_RGB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M66.222,50.524c-.074-7.638-3.5-17.631-9.429-27.471a4.118,4.118,0,0,0-3.528-1.992,3.587,3.587,0,0,0-.42.023q-.466-1.093-.984-2.167a51.769,51.769,0,0,0-6.4-10.093A42.851,42.851,0,0,0,41.5,4.559c-.058-.054-.117-.107-.179-.158A40.6,40.6,0,0,0,35.966.578,4.113,4.113,0,0,0,31.45.8a4,4,0,0,0-.459.391A4.12,4.12,0,0,0,29.654.971a4.061,4.061,0,0,0-.974.117A4.117,4.117,0,0,0,25.548,5.4,4.827,4.827,0,0,1,25.41,7c-.008.033-.016.066-.025.1A8.617,8.617,0,0,1,24.7,8.932a25.951,25.951,0,0,1-2.713,4.232c-.969,1.276-2.071,2.6-3.575,4.285a.133.133,0,0,0-.016.019c-.566.644-1.151,1.284-1.768,1.961-.741.811-1.5,1.651-2.264,2.525a61.049,61.049,0,0,0-7.871,10.8A33.839,33.839,0,0,0,2.148,46.992c-.045.652-.068,1.307-.068,1.945A31.884,31.884,0,0,0,10.294,69.5a31.085,31.085,0,0,0,10.153,7.541A32.857,32.857,0,0,0,34.353,80.01a25.923,25.923,0,0,0,9.906-1.889,23.305,23.305,0,0,0,4.407-2.388,4.116,4.116,0,0,0,3.468-.329,28.546,28.546,0,0,0,14.1-24.63c0-.084,0-.167-.008-.249Z",
    transform: "translate(-2.08 -0.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 195.529,
    height: 59.809,
    rx: 5,
    transform: "translate(73.811 12.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M105.128,66.651c0-7.331-3.579-16.865-8.84-25.6a32.278,32.278,0,0,1,.988,5.532,27.986,27.986,0,0,1-1.354,11.6,56.154,56.154,0,0,0-1.173-11.225,46.322,46.322,0,0,0-3.575-10.386,47.609,47.609,0,0,0-5.888-9.285,38.6,38.6,0,0,0-3.577-3.857A36.362,36.362,0,0,0,76.9,20c3.454,15.167-20.65,27.353-20.65,46.649A24.446,24.446,0,0,0,70.079,88.674c-.418-.916-.755-2.062-1.43-2.311-4.314-1.591-5.833-6.475-5.833-11.52,0-7.642,4.475-16.581,9.706-23.251a13.688,13.688,0,0,0-.714,4.225,41.559,41.559,0,0,1,2.184-4.59,26.123,26.123,0,0,1,2.824-4.04A19.19,19.19,0,0,1,80.43,43.91a17.394,17.394,0,0,1,4.51-2.188c-1.809,5.724,2,10.908,5.629,15.675,3.75,4.929,8,10.515,8,17.443a17.83,17.83,0,0,1-5.5,12.89,24.428,24.428,0,0,0,12.071-21.082h-.006Z",
    transform: "translate(-45.101 -15.886)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M69.783,78.554c0-12.829-16.025-20.932-13.73-31.015a24.179,24.179,0,0,0-3.194,2.283,25.684,25.684,0,0,0-2.379,2.565,31.555,31.555,0,0,0-3.915,6.173,30.77,30.77,0,0,0-2.377,6.9,37.258,37.258,0,0,0-.782,7.463,18.561,18.561,0,0,1-.9-7.712,21.293,21.293,0,0,1,.655-3.678c-3.5,5.8-5.876,12.143-5.876,17.017a16.184,16.184,0,0,0,1.667,7.175,6.911,6.911,0,0,0,6.094,3.207A8.328,8.328,0,0,0,52.1,84.858a13.3,13.3,0,0,0,2.017-7.428,40.826,40.826,0,0,0-1.056-8.424,18.988,18.988,0,0,1,3.24,8.286,14.5,14.5,0,0,1-.121,4.662A10.539,10.539,0,0,1,44.9,90.7c-4.94,0-11.52-4.479-15.453-13.148a22.416,22.416,0,0,1-1.653-5.067,21.345,21.345,0,0,1-.315-2.628c-.027-.434-.035-.9-.031-1.307l.006-.377.012-.315c.008-.21.021-.443.037-.663a27.529,27.529,0,0,1,3.05-10.431,73.748,73.748,0,0,1,6.177-9.818c1.155-1.61,2.348-3.238,3.509-4.942a55.569,55.569,0,0,0,3.2-5.306,25.489,25.489,0,0,0,2.278-5.851,14.049,14.049,0,0,0,.381-3.139,8.384,8.384,0,0,0-.585-3.042,8.914,8.914,0,0,1-.259,2.949,12.713,12.713,0,0,1-1,2.719,30.132,30.132,0,0,1-3.128,4.9c-1.181,1.554-2.46,3.05-3.775,4.528-1.3,1.478-2.686,2.933-4.024,4.477a58.222,58.222,0,0,0-7.375,10.1,29.609,29.609,0,0,0-3.834,12.5c-.039.558-.06,1.12-.06,1.682A27.766,27.766,0,0,0,50.216,95.478c12.526,0,19.567-9.363,19.567-16.929v0h0Z",
    transform: "translate(-17.948 -19.595)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M395.77,224.891v3.692h-.79V220.67h.79V224.1h3.956V220.67h.792v7.914h-.792v-3.692Z",
    transform: "translate(-314.113 -175.254)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M445.442,236.958A.933.933,0,0,0,446.5,235.9h.79a1.632,1.632,0,0,1-1.846,1.846H443.6a1.632,1.632,0,0,1-1.846-1.846v-1.846a1.632,1.632,0,0,1,1.846-1.846h1.846q1.846,0,1.846,1.583c0,.768-.268,1.206-.8,1.319l-3.941.9a.911.911,0,0,0,1.05.949ZM443.6,233a.933.933,0,0,0-1.056,1.056v1.134l3.74-.86a.276.276,0,0,0,.216-.274A.933.933,0,0,0,445.44,233H443.6Z",
    transform: "translate(-351.257 -184.419)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M489.966,233.01a.933.933,0,0,0-1.056,1.056h-.79a1.632,1.632,0,0,1,1.846-1.846h1.846a1.632,1.632,0,0,1,1.846,1.846v1.846a1.632,1.632,0,0,1-1.846,1.846h-1.846q-1.846,0-1.846-1.583,0-1.148.8-1.319l3.941-.9a.911.911,0,0,0-1.05-.949Zm1.846,3.956a.933.933,0,0,0,1.056-1.056v-1.134l-3.74.86a.276.276,0,0,0-.216.274.933.933,0,0,0,1.056,1.056h1.844Z",
    transform: "translate(-388.083 -184.427)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M536.331,230.82a.933.933,0,0,0,1.056,1.056h.527v.792h-.527a1.632,1.632,0,0,1-1.846-1.846v-2.9h-.79v-.79h.79V225.81h.792v1.319h1.319v.79h-1.319v2.9h0Z",
    transform: "translate(-425.116 -179.336)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M570.057,224.944a.527.527,0,1,1,.527-.527A.466.466,0,0,1,570.057,224.944Zm-.4,6.2V225.6h.79v5.541Z",
    transform: "translate(-452.738 -177.811)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M597.37,233h-2.11v4.748h-.79V232.21h2.9a2.332,2.332,0,0,1,2.639,2.639v2.9h-.792v-2.9A1.632,1.632,0,0,0,597.372,233Z",
    transform: "translate(-472.545 -184.419)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M641.44,234.056a1.632,1.632,0,0,1,1.846-1.846h1.846a1.632,1.632,0,0,1,1.846,1.846v4.221a1.632,1.632,0,0,1-1.846,1.846H641.44v-.792h3.692a.933.933,0,0,0,1.056-1.056v-.527h-2.9a1.632,1.632,0,0,1-1.846-1.846v-1.846ZM643.286,233a.933.933,0,0,0-1.056,1.056V235.9a.933.933,0,0,0,1.056,1.056h2.9v-2.9A.933.933,0,0,0,645.132,233Z",
    transform: "translate(-509.847 -184.419)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M722.07,235.833a1.106,1.106,0,0,1,.34-.817,1.123,1.123,0,0,1,.821-.335,1.157,1.157,0,1,1-.823,1.974,1.125,1.125,0,0,1-.338-.821h0Z",
    transform: "translate(-573.882 -186.38)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M782.195,226.219l-.681,2.375h-.823l2.268-7.914h1.013l2.268,7.914h-.823l-.681-2.375h-2.54Zm1.272-4.442-1.046,3.651h2.089Z",
    transform: "translate(-620.437 -175.262)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M827.267,224.944a.527.527,0,1,1,.527-.527A.466.466,0,0,1,827.267,224.944Zm-.4,6.2V225.6h.79v5.541Z",
    transform: "translate(-657.009 -177.811)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M854.009,232.2h2.11v.79h-2.11a1.632,1.632,0,0,0-1.846,1.846v2.9h-.792v-2.9a2.332,2.332,0,0,1,2.639-2.639h0Z",
    transform: "translate(-676.57 -184.411)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M928.16,235.833a1.106,1.106,0,0,1,.34-.817,1.123,1.123,0,0,1,.821-.335,1.157,1.157,0,1,1-.825,1.974,1.123,1.123,0,0,1-.335-.821h0Z",
    transform: "translate(-737.555 -186.38)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M992.961,220.68v.792h-4.748v2.639h3.956v.79h-3.956v2.9h4.748v.792H987.42v-7.914h5.541Z",
    transform: "translate(-784.618 -175.262)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M1034.4,228.594V220.68h.79v7.914Z",
    transform: "translate(-821.928 -175.262)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M1061.962,236.958a.932.932,0,0,0,1.054-1.056h.792a1.632,1.632,0,0,1-1.846,1.846h-1.846a1.632,1.632,0,0,1-1.846-1.846v-1.846a1.632,1.632,0,0,1,1.846-1.846h1.846q1.846,0,1.846,1.583c0,.768-.268,1.206-.8,1.319l-3.942.9a.911.911,0,0,0,1.05.949ZM1060.116,233a.933.933,0,0,0-1.056,1.056v1.134l3.74-.86a.276.276,0,0,0,.216-.274.933.933,0,0,0-1.054-1.056Z",
    transform: "translate(-840.885 -184.419)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M1108.332,236.958a.933.933,0,0,0,1.056-1.056h.79a1.632,1.632,0,0,1-1.846,1.846h-1.846a1.632,1.632,0,0,1-1.846-1.846v-1.846a1.632,1.632,0,0,1,1.846-1.846h1.846a1.632,1.632,0,0,1,1.846,1.846h-.79a.933.933,0,0,0-1.056-1.056h-1.846a.933.933,0,0,0-1.056,1.056V235.9a.933.933,0,0,0,1.056,1.056Z",
    transform: "translate(-877.712 -184.419)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M1152.843,230.82a.933.933,0,0,0,1.054,1.056h.527v.792h-.527a1.632,1.632,0,0,1-1.846-1.846v-2.9h-.79v-.79h.79V225.81h.792v1.319h1.319v.79h-1.319v2.9h0Z",
    transform: "translate(-914.736 -179.336)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M1189.319,232.2h2.11v.79h-2.11a1.632,1.632,0,0,0-1.846,1.846v2.9h-.792v-2.9a2.333,2.333,0,0,1,2.639-2.639h0Z",
    transform: "translate(-942.866 -184.411)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M1229.677,224.944a.527.527,0,1,1,.527-.527A.466.466,0,0,1,1229.677,224.944Zm-.4,6.2V225.6h.792v5.541Z",
    transform: "translate(-976.595 -177.811)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M1257.49,236.958a.933.933,0,0,0,1.056-1.056h.792a1.632,1.632,0,0,1-1.846,1.846h-1.846a1.632,1.632,0,0,1-1.846-1.846v-1.846a1.632,1.632,0,0,1,1.846-1.846h1.846a1.632,1.632,0,0,1,1.846,1.846h-.792A.933.933,0,0,0,1257.49,233h-1.846a.933.933,0,0,0-1.056,1.056V235.9a.933.933,0,0,0,1.056,1.056Z",
    transform: "translate(-996.172 -184.419)",
    fill: "#5d9921"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M392.853,290.455h3.174l-.235,1.066h-3.174l-.381,1.8h3.373l-.235,1.113H390.7l1.439-6.784h4.649l-.235,1.113h-3.347l-.352,1.692h0Z",
    transform: "translate(-310.714 -228.448)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M421.908,299.8l1,2.5h-1.338l-.589-1.737-1.319,1.737H418.31l2.1-2.5-.9-2.252h1.3l.5,1.519,1.148-1.519h1.321l-1.863,2.252Z",
    transform: "translate(-332.642 -236.31)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M451.919,300.275c-.333,1.556-.959,1.863-2.56,1.863-1.745,0-2.017-.506-1.609-2.425.352-1.663.778-2.433,2.641-2.433,1.41,0,2.116.216,1.791,1.719h-1.14c.154-.722-.045-.85-.842-.85-.978,0-1.058.344-1.311,1.564-.253,1.186-.352,1.556.65,1.556.932,0,1.058-.163,1.239-.994Z",
    transform: "translate(-355.889 -236.096)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M480.3,300.581c-.317,1.492-1.186,1.564-2.542,1.564-1.817,0-2.071-.578-1.682-2.414.362-1.7.8-2.441,2.713-2.441s2.089.57,1.655,2.641h-3.264c-.218,1.023-.261,1.348.759,1.348.634,0,1.076.008,1.221-.7h1.14Zm-.842-1.375c.208-.976.072-1.05-.858-1.05-.986,0-1.085.208-1.266,1.05h2.126Z",
    transform: "translate(-378.392 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M504.488,298.05h.037a1.764,1.764,0,0,1,1.647-.77c1.764,0,1.583,1.111,1.276,2.569-.3,1.393-.679,2.289-2.307,2.289-.578,0-1.167-.109-1.284-.687h-.045l-.57,2.686H502.1l1.447-6.8h1.14Zm1.817,1.8c.226-1.076.381-1.7-.661-1.7-1.167,0-1.258.57-1.492,1.7-.216,1.013-.154,1.42.832,1.42.786,0,1.058-.226,1.319-1.42Z",
    transform: "translate(-399.186 -236.096)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M535.9,293.4h.6l.226-1.076h1.14l-.226,1.076h1.817l-.189.869h-1.817l-.515,2.433c-.082.434-.128.634.352.634.642,0,.679-.506.786-1h1c-.29,1.439-.741,1.873-1.972,1.873s-1.564-.29-1.311-1.492l.517-2.441h-.6l.189-.869h0Z",
    transform: "translate(-425.879 -232.157)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M558.11,294.452h-1.14l1.013-4.748h1.14Zm1.239-5.814h-1.14l.2-.967h1.14Z",
    transform: "translate(-442.763 -228.464)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M577.2,299.723c-.389,1.836-.768,2.425-2.75,2.425s-2.108-.589-1.719-2.425.77-2.433,2.75-2.433S577.587,297.879,577.2,299.723Zm-3.336.008c-.261,1.266-.245,1.546.768,1.546s1.157-.28,1.42-1.546c.28-1.284.253-1.575-.76-1.575S574.142,298.447,573.862,299.731Z",
    transform: "translate(-455.139 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M603.373,297.336l-.154.714h.035a1.629,1.629,0,0,1,1.655-.77c1.247,0,1.519.515,1.276,1.673l-.669,3.128h-1.14l.642-3.011c.144-.687.035-.922-.7-.922-.994,0-1.231.471-1.41,1.321l-.552,2.614h-1.14l1.013-4.748Z",
    transform: "translate(-477.905 -236.096)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M634.758,301.487h-.027a1.648,1.648,0,0,1-1.609.65c-1.076,0-1.727-.226-1.457-1.511.245-1.14.9-1.457,2.081-1.457.578,0,1.148.008,1.311.543h.037l.128-.615c.163-.77.163-1.039-.786-1.039-.5,0-.9.045-1.039.661h-1.14c.3-1.383,1.258-1.439,2.342-1.439,1.519,0,2.1.235,1.764,1.828l-.634,2.976h-1.14l.171-.6Zm-1.953-.858c-.144.669.117.733.887.733.605,0,1.058-.054,1.2-.733.144-.661-.344-.679-.9-.679S632.951,299.95,632.805,300.629Z",
    transform: "translate(-502.036 -236.096)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M662.1,294.444h-1.14l1.439-6.784h1.14Z",
    transform: "translate(-525.35 -228.456)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M697.961,292.076l-.072.317c-.163.778.163.832,1.367.832s1.393-.216,1.556-1c.208-.967-.336-.842-1.338-.9-1.439-.091-2.614-.037-2.188-2.007.389-1.863,1.583-1.918,3.211-1.918,1.383,0,2.5.045,2.126,1.828l-.045.218h-1.3l.045-.218c.154-.733-.136-.759-1.05-.759-1.292,0-1.529.128-1.682.85-.181.832-.018.858,1.293.941,2.062.128,2.606.235,2.233,1.964-.4,1.908-1.338,2.071-3.083,2.071-1.5,0-2.849.045-2.443-1.9l.072-.317h1.3Z",
    transform: "translate(-553.587 -228.25)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M734.9,300.581c-.317,1.492-1.186,1.564-2.542,1.564-1.817,0-2.071-.578-1.682-2.414.362-1.7.8-2.441,2.713-2.441s2.089.57,1.655,2.641h-3.264c-.218,1.023-.261,1.348.76,1.348.634,0,1.076.008,1.22-.7h1.14Zm-.842-1.375c.208-.976.072-1.05-.858-1.05-.986,0-1.085.208-1.266,1.05h2.124Z",
    transform: "translate(-580.59 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M760.732,297.343l-.163.624h.045a1.546,1.546,0,0,1,1.412-.677c1,0,1.122.6.932,1.492l-.08.381h-1.068l.053-.245c.1-.48.109-.759-.424-.759-.679,0-.959.389-1.066,1l-.624,2.931h-1.14l1.013-4.748h1.109Z",
    transform: "translate(-602.901 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M787.783,302.3h-1.719l-.424-4.748h1.167l.263,3.97h.027l1.889-3.97h1.194l-2.4,4.748Z",
    transform: "translate(-624.368 -236.31)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M809.99,294.452h-1.14l1.013-4.748H811Zm1.239-5.814h-1.14l.2-.967h1.14l-.2.967h0Z",
    transform: "translate(-642.801 -228.464)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M828.709,300.275c-.335,1.556-.959,1.863-2.56,1.863-1.745,0-2.017-.506-1.609-2.425.352-1.663.778-2.433,2.641-2.433,1.41,0,2.116.216,1.791,1.719h-1.14c.154-.722-.045-.85-.842-.85-.978,0-1.058.344-1.311,1.564-.253,1.186-.352,1.556.65,1.556.932,0,1.058-.163,1.239-.994Z",
    transform: "translate(-655.129 -236.096)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M857.088,300.581c-.317,1.492-1.185,1.564-2.542,1.564-1.817,0-2.071-.578-1.682-2.414.362-1.7.8-2.441,2.713-2.441s2.089.57,1.655,2.641h-3.264c-.216,1.023-.261,1.348.76,1.348.634,0,1.076.008,1.22-.7h1.14Zm-.842-1.375c.208-.976.072-1.05-.858-1.05-.986,0-1.085.208-1.266,1.05h2.124Z",
    transform: "translate(-677.631 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M879.469,316.508c.333,0,.56-.1.669-.607h-.453l.261-1.221h1.14l-.226,1.068c-.171.778-.317,1.293-1.284,1.293h-.226l.117-.533h0Z",
    transform: "translate(-698.791 -249.915)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M920.981,290.455h3.174l-.235,1.066h-3.174l-.379,1.8h3.373l-.235,1.113H918.83l1.439-6.784h4.649l-.235,1.113h-3.347l-.352,1.692h0Z",
    transform: "translate(-730.145 -228.448)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M950.028,299.8l1,2.5h-1.338l-.587-1.737-1.321,1.737H946.43l2.1-2.5-.9-2.252h1.3l.5,1.519,1.148-1.519h1.321l-1.863,2.252Z",
    transform: "translate(-752.064 -236.31)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M975.175,298.05h.037a1.764,1.764,0,0,1,1.646-.77c1.764,0,1.583,1.111,1.276,2.569-.3,1.393-.677,2.289-2.305,2.289-.578,0-1.167-.109-1.284-.687H974.5l-.57,2.686h-1.14l1.447-6.8h1.14l-.2.714Zm1.817,1.8c.226-1.076.379-1.7-.661-1.7-1.167,0-1.258.57-1.492,1.7-.218,1.013-.154,1.42.832,1.42.786,0,1.058-.226,1.321-1.42Z",
    transform: "translate(-772.999 -236.096)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M1010.228,300.581c-.317,1.492-1.186,1.564-2.542,1.564-1.817,0-2.071-.578-1.682-2.414.362-1.7.8-2.441,2.713-2.441s2.089.57,1.655,2.641h-3.264c-.216,1.023-.263,1.348.76,1.348.634,0,1.076.008,1.22-.7h1.14Zm-.842-1.375c.208-.976.072-1.05-.858-1.05-.986,0-1.085.208-1.266,1.05h2.124Z",
    transform: "translate(-799.252 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M1036.054,297.343l-.163.624h.045a1.546,1.546,0,0,1,1.412-.677c1,0,1.122.6.932,1.492l-.08.381h-1.068l.053-.245c.1-.48.109-.759-.424-.759-.679,0-.959.389-1.068,1l-.624,2.931h-1.14l1.013-4.748h1.111Z",
    transform: "translate(-821.555 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M1060.609,293.4h.6l.226-1.076h1.14l-.226,1.076h1.817l-.189.869h-1.817l-.515,2.433c-.08.434-.125.634.352.634.642,0,.679-.506.786-1h1c-.29,1.439-.741,1.873-1.972,1.873s-1.564-.29-1.311-1.492l.514-2.441h-.6l.189-.869h0Z",
    transform: "translate(-842.593 -232.157)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M1103.892,292.2l-.479,2.243h-1.3l1.439-6.784h3.464c1.484.037,1.953.5,1.628,2.036-.218,1-.426,1.737-1.609,1.908l-.008.037c.9.082,1.021.578.823,1.537l-.272,1.266h-1.3l.272-1.266c.117-.57-.027-.967-.65-.978Zm1.953-1.111c.959,0,1.231-.189,1.447-1.186.2-.959.064-1.13-.869-1.13h-1.809l-.488,2.315Z",
    transform: "translate(-875.702 -228.456)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M1142.818,300.581c-.317,1.492-1.186,1.564-2.542,1.564-1.817,0-2.071-.578-1.682-2.414.362-1.7.8-2.441,2.713-2.441s2.089.57,1.655,2.641H1139.7c-.216,1.023-.261,1.348.76,1.348.634,0,1.076.008,1.22-.7h1.14Zm-.842-1.375c.208-.976.072-1.05-.858-1.05-.986,0-1.085.208-1.266,1.05h2.126Z",
    transform: "translate(-904.552 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M1167,298.05h.035a1.764,1.764,0,0,1,1.647-.77c1.764,0,1.583,1.111,1.276,2.569-.3,1.393-.679,2.289-2.307,2.289-.578,0-1.167-.109-1.284-.687h-.045l-.57,2.686h-1.14l1.447-6.8h1.14l-.2.714Zm1.817,1.8c.226-1.076.381-1.7-.661-1.7-1.167,0-1.258.57-1.492,1.7-.218,1.013-.154,1.42.832,1.42.786,0,1.058-.226,1.321-1.42Z",
    transform: "translate(-925.339 -236.096)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M1200.253,301.487h-.027a1.648,1.648,0,0,1-1.61.65c-1.076,0-1.727-.226-1.455-1.511.245-1.14.9-1.457,2.081-1.457.578,0,1.148.008,1.311.543h.037l.128-.615c.163-.77.163-1.039-.786-1.039-.5,0-.9.045-1.039.661h-1.14c.3-1.383,1.258-1.439,2.342-1.439,1.519,0,2.1.235,1.764,1.828l-.634,2.976h-1.14l.173-.6Zm-1.953-.858c-.144.669.117.733.887.733.605,0,1.058-.054,1.2-.733.144-.661-.344-.679-.9-.679S1198.446,299.95,1198.3,300.629Z",
    transform: "translate(-951.142 -236.096)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M1227.41,294.452h-1.14l1.013-4.748h1.14Zm1.239-5.814h-1.14l.2-.967h1.14Z",
    transform: "translate(-974.308 -228.464)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M1243.056,297.343l-.163.624h.045a1.546,1.546,0,0,1,1.412-.677c1,0,1.122.6.932,1.492l-.082.381h-1.068l.053-.245c.1-.48.109-.759-.424-.759-.679,0-.959.389-1.068,1l-.624,2.931h-1.14l1.013-4.748h1.114Z",
    transform: "translate(-985.95 -236.104)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M1267.35,294.444h-1.14l.261-1.239h1.14Zm.479-2.27h-1.14l.887-4.514h1.284Z",
    transform: "translate(-1006.027 -228.456)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M1284.824,288.746a1.519,1.519,0,0,1,.335-.486,1.568,1.568,0,0,1,.494-.323,1.547,1.547,0,0,1,2.019.809,1.488,1.488,0,0,1,.123.605,1.537,1.537,0,0,1-.123.615,1.568,1.568,0,0,1-.333.49,1.5,1.5,0,0,1-.49.323,1.609,1.609,0,0,1-1.2,0,1.524,1.524,0,0,1-.829-.813,1.514,1.514,0,0,1-.124-.615A1.465,1.465,0,0,1,1284.824,288.746Zm.253,1.13a1.247,1.247,0,0,0,.671.7,1.24,1.24,0,0,0,.5.1,1.211,1.211,0,0,0,.5-.1,1.252,1.252,0,0,0,.4-.278,1.276,1.276,0,0,0,.268-.418,1.408,1.408,0,0,0,.1-.525,1.347,1.347,0,0,0-.1-.515,1.278,1.278,0,0,0-.268-.414,1.246,1.246,0,0,0-.4-.276,1.218,1.218,0,0,0-.5-.1,1.255,1.255,0,0,0-.908.377,1.276,1.276,0,0,0-.268.414,1.37,1.37,0,0,0-.1.515A1.432,1.432,0,0,0,1285.077,289.876Zm1.27-1.418a.741.741,0,0,1,.475.128.472.472,0,0,1,.154.387.438.438,0,0,1-.136.356.613.613,0,0,1-.338.134l.515.794h-.3l-.49-.774h-.3v.774h-.28v-1.8Zm-.124.8a1.659,1.659,0,0,0,.179-.006.474.474,0,0,0,.15-.035.243.243,0,0,0,.1-.089.294.294,0,0,0,.039-.167.266.266,0,0,0-.035-.144.231.231,0,0,0-.091-.082.4.4,0,0,0-.128-.039,1.1,1.1,0,0,0-.142-.01h-.37v.572Z",
    transform: "translate(-1020.712 -228.583)",
    fill: "#308ab4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M36.343,14.35V0h3.876V14.35c0,2.073.753,2.692,4.5,2.692s4.549-.512,4.549-2.692V0h3.88V14.35c0,5.625-3.526,6-8.426,6S36.343,20,36.343,14.35Zm131.809,5.845V0H181.99V3.316h-9.96V8.348h9.447v3.178H172.03v5.358h10.04v3.311Zm-111.056,0V0H70.934V3.316H60.972V8.348h9.449v3.178H60.972v5.358H71.014v3.311Zm103.167,0,.323-17.013h-.136L154.1,20.193h-3.472L144.218,3.26h-.08l.323,16.933h-3.876V0H146.8L152.294,15h.107L157.785,0h6.354V20.193Zm-57.514,0V0h3.878V16.881h9.42v3.311Zm3.878-3.311h0ZM85.985,20.193V0H99.337V3.314H89.861V8.671h8.99v3.176h-8.99v8.346Zm-65.928,0V0h3.876V16.881h9.422v3.311ZM0,20.193V0H10.04C14,0,15.99.811,15.99,5.253c0,2.315-.43,3.876-2.88,4.468V9.83c2.826.323,3.365,2.18,3.365,4.738,0,4.468-1.83,5.625-6.084,5.625Zm3.876-3.314v0h5.3c2.315,0,3.419-.161,3.419-2.639,0-2.208-.484-2.855-2.772-2.855H3.876Zm0-8.424H9.447c2.182,0,2.665-.673,2.665-2.826s-.86-2.315-2.772-2.315H3.876Zm129.73,11.736-1.319-3.822h-8.721L122.3,20.191h-4.012L124.992,0H130.7l6.837,20.191Zm-9.151-6.755h6.973L127.956,2.964H127.9Z",
    transform: "translate(80.539 18.579)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1540);
export default __webpack_public_path__ + "static/media/logo_1540.f47a2e54a83401bdf90094a8ffe8ab62.svg";
export { ForwardRef as ReactComponent };